import ButtonPrimary from '../../ButtonPrimary'

const ButtonPrimaryGhostWhitRightIcon = ({
  title,
  disabled = false,
  loading = false,
  onClick = () => {},
  icon = null,
  ...props
}) => {
  return (
    <ButtonPrimary
      {...props}
      ghost
      title={title}
      icon={icon}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    />
  )
}

export default ButtonPrimaryGhostWhitRightIcon
